import React from 'react';
import { Link } from 'react-router-dom';
import { primaryLogoInverted } from '../../assets/v2';
import './footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleLegalPageClick = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="v2-footer">
      <div className="v2-footer__container">
        <div className="v2-footer__grid">
          <div className="v2-footer__brand">
            <img
              src={primaryLogoInverted}
              alt="Morph"
              className="v2-footer__logo"
            />
            <p>Home Inspection Software. Instant Reports. Real Impact.</p>
          </div>
          <div className="v2-footer__col">
            <h4>Product</h4>
            <a href="#how-it-works">AI Inspection</a>
            <a href="#web-report">Sample Report</a>
            <a href="#business-tools">Business Tool</a>
            <a href="#pricing">Pricing</a>
          </div>
          <div className="v2-footer__col">
            <h4>Company</h4>
            <a href="#about">About</a>
            <a href="mailto:info@morph-technologies.com">Contact</a>
          </div>
          <div className="v2-footer__col">
            <h4>Legal</h4>
            <Link to="/privacy-policy" onClick={handleLegalPageClick}>
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" onClick={handleLegalPageClick}>
              Terms of Service
            </Link>
          </div>
        </div>
        <div className="v2-footer__bottom">
          <p>&copy; {currentYear} Morph Inspection. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
